<template>
    
  <div>

    <page-padding>
      <div v-if="!hasEmails">{{$t('language.no_emails')}}</div>
    </page-padding>

   <infinite-list v-if="hasEmails" :list='emails[group_id+"emails"]'>
     
        <template v-slot:default="email">
         
          <button-email :item="email.item"></button-email>
         
      </template>
    </infinite-list>


  </div>
</template>

<script>

import { mapState } from 'vuex';
import PagePadding from '../../components/PagePadding';
import InfiniteList from '../../components/InfiniteList.vue';
import ButtonEmail from './ButtonEmail.vue';
import { eventBus } from '../../services/EventBus.js';

export default {
  name: 'list-emails',
  props:{
    group_id:{default:0},
  },
  data:function(){
    return {
      showLoader:false,
    }
  },
  components:{
    PagePadding,
    InfiniteList,
    ButtonEmail,
  },
  methods:{
     emitLoadStart(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_START_LOAD')
        vm=vm.$parent;
      }
    },
    emitLoadEnd(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_END_LOAD')
        vm=vm.$parent;
      }
    },
    load_emails(){
      this.emitLoadStart();
      this.$store.dispatch('get_emails',{store_key:this.group_id+"emails", group_id:this.group_id}).then(()=>{
       
        this.emitLoadEnd();
      })
    }
  },
  computed:{
    ...mapState([
       'emails',
       ]),
       hasEmails:function(){
         if(this.emails[this.group_id+"emails"]){
           return this.emails[this.group_id+"emails"] ? this.emails[this.group_id+"emails"].length : false;
         }else{
           return false;
         }
       }
  },
  beforeDestroy(){
   
      eventBus.$off("RELOAD_FROM_PULL",this.load_emails)
    },
  created:function(){
    this.load_emails();
    eventBus.$on("RELOAD_FROM_PULL",this.load_emails)
  },  
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



</style>

